<div class="panel widget">
    <div class="panel-heading-flex">
        <div class="panel-title no-uppercase">Your Missions</div>
        <div class="panel-content"></div>
        <div class="panel-buttons">
            <button
                class="btn btn-inline"
                (click)="onToggleCollapse()"
                [tooltip]="showBody ? 'Hide' : 'Show'"
                placement="left"
            >
                <i *ngIf="showBody" class="fa-chevron-up fa no-border"></i>
                <i *ngIf="!showBody" class="fa-chevron-down fa no-border"></i>
            </button>
        </div>
    </div>
    <div *ngIf="showBody" class="panel-body" @expandOnEnter @collapseOnLeave>
        <form [formGroup]="formGroup">
            <div
                class="input-group no-wrap"
                btnRadioGroup
                formControlName="filterSelection"
            >
                <label
                    class="btn btn-sm btn-pill"
                    btnRadio="UPCOMING"
                    tooltip
                    placement="top"
                    enhancedHelp="upcoming-filter"
                    >Upcoming Missions</label
                >
                <label
                    class="btn btn-sm btn-pill"
                    btnRadio="ACTIVATED"
                    tooltip
                    placement="top"
                    enhancedHelp="assigned-filter"
                    >Active Missions</label
                >
                <label
                    class="btn btn-sm btn-pill"
                    btnRadio="INACTIVE_APPROVALS"
                    tooltip
                    placement="top"
                    enhancedHelp="archived-filter"
                    >Approvals Requiring Attention</label
                >
                <label
                    *ngIf="canUseFlightConformance"
                    class="btn btn-sm btn-pill"
                    btnRadio="CONFORMANCE_BREACHES"
                    tooltip
                    placement="top"
                    enhancedHelp="archived-filter"
                    >Missions With Conformance Breaches</label
                >
            </div>
        </form>
        <p class="help-block">{{ modeGuidanceText }}</p>
        <div class="static-table-container no-actions" *ngIf="missions">
            <static-table
                [availableColumns]="availableColumns"
                [selectedColumns]="selectedColumns"
                [tableData]="missions"
                [tableConfig]="tableConfig"
                [borderless]="false"
                [underlinedRows]="true"
                scanability="comfortable"
                (pageChanged)="onTablePageChanged($event)"
                (selectedColumnsChanged)="
                    updateSelectedColumns($event.selectedColumns)
                "
                (sortOrderChanged)="updateColumnSorting($event)"
                (itemLimitUpdated)="updateItemLimit($event)"
            >
                <ng-template
                    columnTemplate="rpic"
                    let-row="row"
                    let-column="column"
                >
                    <div style="width: 200px">
                        <person-avatar
                            [person]="row.rpic"
                            [managingOrganisationId]="organisation.id"
                        ></person-avatar>
                    </div>
                </ng-template>
            </static-table>
        </div>
        <loading-indicator [isLoading]="working"></loading-indicator>
    </div>
</div>
